import React, { useState } from 'react'
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
//import Button from "material-ui/Button";

const SearchDiv = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  //{/*borderRadius: "10px"*/}
  borderRadius: theme.shape.borderRadius,
  width: "100%",
  fontSize: "14px",
  marginBottom: "10px"
}));


const InputBaseX = styled(InputBase)({
  
  width: "100%",
  fontSize: "14px",
  height: "95%",
  marginBottom: "2px",
  marginTop: "2px",
});

const placeholderFirstName="Enter First Name";
const ModalShowButton = styled("Button")(({ theme }) => ({
    //backgroundColor: "blue",
    //{/*borderRadius: "10px"*/}
    borderRadius: theme.shape.borderRadius,
    width: "75%",
    fontSize: "14px",
    
  }));
  
  const ContainerDiv = styled("div")(({ theme }) => ({
    marginLeft: "20px",
    marginRight: "20px",
    width: "100%",
    height: "75px"
  }));

  const StyledBox= styled(Box)({
    width: "100%",
    marginLeft: "30px",
    marginRight: "10px",
    marginTop: "30px",
  })

  const handleClick=()=>{
    alert("");
    //setName1('XYZ');
}


const InputRctX = (props) =>{
    return (
      <SearchDiv>
      <InputBaseX className={props.inputClass} id={props.inputId} name={props.inputIName} placeholder={props.inputPlaceholder} onChange={props.onChange} />
      </SearchDiv>
      
      )
  }
  export default InputRctX